/* jh-duties-fee.js
   Adds the "Duties & Services" product to the cart for Middle East customers only.
   Removes it for everyone else (including UK). Loaded from jh-header.liquid.

   Also keeps it positioned AFTER your real products in the cart/checkout order:
   whenever a new product is added, the fee removes itself and re-adds itself
   fresh, which puts it at the end of the cart's item list. */
(function () {
  "use strict";

  var FEE_HANDLE = "duties-and-services";
  var FEE_COUNTRIES = ["SA", "AE", "QA", "KW", "BH", "OM"];

  var current = null;      // the sync running right now (if any)
  var feeVariantId = null;

  function isFeeCountry() {
    var c = ((window.Shopify && window.Shopify.country) || "").toUpperCase();
    return FEE_COUNTRIES.indexOf(c) !== -1;
  }

  function getFeeVariant() {
    if (feeVariantId) { return Promise.resolve(feeVariantId); }
    return fetch("/products/" + FEE_HANDLE + ".js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (p && p.variants && p.variants.length) { feeVariantId = p.variants[0].id; }
        return feeVariantId;
      })
      .catch(function () { return null; });
  }

  function post(url, body) {
    return fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function getCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); });
  }

  function removeFee(vid) {
    var u = {}; u[vid] = 0;
    return post("/cart/update.js", { updates: u });
  }

  function addFee(vid) {
    return post("/cart/add.js", { items: [{ id: vid, quantity: 1 }] });
  }

  /* reposition = true: if the fee should be present, remove it and add it
     again fresh, so it lands at the END of the cart's item list (after any
     product that was just added). Used right after a real product is added. */
  function sync(reposition) {
    if (current) { return current; }

    current = Promise.all([getCart(), getFeeVariant()]).then(function (res) {
      var cart = res[0];
      var vid = res[1];
      if (!vid) { return false; } // fee product not found: do nothing

      var feeQty = 0, otherItems = 0, feeIsLast = true;
      for (var i = 0; i < cart.items.length; i++) {
        var it = cart.items[i];
        if (it.variant_id === vid) {
          feeQty += it.quantity;
          if (i !== cart.items.length - 1) { feeIsLast = false; }
        } else {
          otherItems += it.quantity;
        }
      }

      var wanted = (isFeeCountry() && otherItems > 0) ? 1 : 0;

      if (wanted === 0) {
        if (feeQty === 0) { return false; }       // already correctly absent
        return removeFee(vid).then(function () { return true; });
      }

      /* wanted === 1 from here on */
      if (feeQty === 0) {
        return addFee(vid).then(function () { return true; });
      }
      if (reposition && !feeIsLast) {
        /* already present but sitting above a product that was just added:
           remove it, then add it fresh so it moves to the end */
        return removeFee(vid)
          .then(function () { return addFee(vid); })
          .then(function () { return true; });
      }
      return false; // already present and already in the right place
    }).catch(function () {
      return false;
    }).then(function (changed) {
      current = null;
      if (changed) {
        document.dispatchEvent(new CustomEvent("jh:cart:changed"));
        if (/\/cart\/?$/.test(location.pathname)) { location.reload(); }
      }
      return changed;
    });

    return current;
  }

  window.jhDutiesFeeSync = function () { return sync(true); };

  /* Asks Shopify for the REAL shipping price for the customer's country,
     so the cart shows the same shipping as checkout. Returns null if it can't. */
  window.jhRealShipping = function () {
    var c = (window.Shopify && window.Shopify.country) || "";
    if (!c) { return Promise.resolve(null); }
    return fetch("/cart/shipping_rates.json?shipping_address[country]=" + encodeURIComponent(c))
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var rates = d && d.shipping_rates;
        if (!rates || !rates.length) { return null; }
        var best = null;
        rates.forEach(function (x) {
          var p = Math.round(parseFloat(x.price) * 100);
          if (isNaN(p)) { return; }
          if (!best || p < best.cents) { best = { cents: p, currency: x.currency || null }; }
        });
        return best;
      })
      .catch(function () { return null; });
  };

  /* Re-check after any cart change made elsewhere on the site.
     A new ADD repositions the fee to the end; a quantity change/remove
     just re-checks whether the fee is still needed, without moving it. */
  var origFetch = window.fetch;
  window.fetch = function () {
    var a = arguments[0];
    var url = (a && a.url) ? a.url : String(a);
    var p = origFetch.apply(this, arguments);
    if (!current) {
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function () { setTimeout(function () { sync(true); }, 300); }).catch(function () {});
      } else if (/\/cart\/(change|update|clear)/.test(url)) {
        p.then(function () { setTimeout(function () { sync(false); }, 300); }).catch(function () {});
      }
    }
    return p;
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { sync(false); });
  } else {
    sync(false);
  }
})();